import axios from "axios";
import api from "@/plugins/api";
/**
 * Fetches the current user's donation view preferences from the BFF.
 * Returns null when none have been recorded yet (BFF responds 404).
 */
export async function getDonationViews() {
    try {
        const response = await api.get("/donation-views", {
            unwrapEnvelope: true,
        });
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
}
/** Persists the current user's donation view preferences via the BFF. */
export async function saveDonationViews(prefs) {
    await api.put("/donation-views", prefs, {
        unwrapEnvelope: true,
    });
}
